// ChatWindow.js

import React, { useState, useEffect, useRef } from "react";
import {
    collection,
    addDoc,
    onSnapshot,
    orderBy,
    query,
    serverTimestamp,
    doc,
    updateDoc
} from './firestore-compat';
import { db, auth } from "./firebase";

function ChatWindow({ chamadoId, isTecnico, solicitanteNome, assignedToName }) {
    const [mensagens, setMensagens] = useState([]);
    const [novaMsg, setNovaMsg] = useState("");
    const chatRef = useRef(null);
    const chamadoIdStr = String(chamadoId);

    useEffect(() => {
        if (!chamadoIdStr) return;

        // 1. Define a subcoleção de mensagens
        const mensagensRef = collection(db, "chamados", chamadoIdStr, "mensagens");
        const q = query(mensagensRef, orderBy("timestamp", "asc"));

        // 2. Escuta em tempo real
        const unsub = onSnapshot(q, (snapshot) => {
            const lista = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
            setMensagens(lista);
            // Rola para a última mensagem
            setTimeout(() => {
                chatRef.current?.scrollTo(0, chatRef.current.scrollHeight);
            }, 200);
        });

        return () => unsub();
    }, [chamadoIdStr]);

    const enviarMensagem = async () => {
        if (novaMsg.trim() === "") return;

        const mensagensRef = collection(db, "chamados", chamadoIdStr, "mensagens");

        // Determina o autor e o tipo da mensagem
        const autor = isTecnico
            ? assignedToName || auth.currentUser?.email || "Técnico"
            : solicitanteNome || "Solicitante";

        const tipo = isTecnico ? "responsavel" : "solicitante";

        try {
            // 1. Adiciona a mensagem na subcoleção
            await addDoc(mensagensRef, {
                texto: novaMsg,
                de: autor,
                tipo: tipo,
                timestamp: serverTimestamp(),
            });

            // 2. Atualiza o chamado pai para sinalizar nova mensagem
            const chamadoRef = doc(db, "chamados", chamadoIdStr);
            await updateDoc(chamadoRef, {
                hasMessages: true,
                lastMessageAt: serverTimestamp(),
                lastMessageBy: tipo // 'responsavel' ou 'solicitante'
            });

            setNovaMsg("");
        } catch (error) {
            alert("Erro ao enviar mensagem. Tente novamente.");
            console.error("Erro ao enviar mensagem: ", error);
        }
    };

    const isMe = (msg) => {
        if (isTecnico) {
            return msg.tipo === 'responsavel';
        } else {
            return msg.tipo === 'solicitante';
        }
    };

    return (
        <div className="chat-container-wrapper">
            {/* O Container de Mensagens */}
            <div className="modal-chat-messages" ref={chatRef}>
                {mensagens.length === 0 && (
                    <div className="chat-empty" style={{ textAlign: 'center', color: '#888', marginTop: '20px' }}>
                        <p>Nenhuma mensagem ainda.</p>
                        <small>Inicie a conversa!</small>
                    </div>
                )}
                {mensagens.map((msg) => {
                    const me = isMe(msg);
                    return (
                        <div
                            key={msg.id}
                            className={`modal-chat-bubble ${me ? "me" : "other"}`}
                        >
                            {!me && <p className="modal-chat-author">{msg.de}</p>}
                            <p style={{ margin: 0 }}>{msg.texto}</p>
                            {msg.timestamp && (
                                <span className="modal-chat-time">
                                    {new Date(msg.timestamp.seconds * 1000).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}
                                </span>
                            )}
                        </div>
                    );
                })}
            </div>

            {/* A Área de Input */}
            <div className="modal-chat-input-area">
                <input
                    type="text"
                    placeholder="Digite sua mensagem..."
                    value={novaMsg}
                    onChange={(e) => setNovaMsg(e.target.value)}
                    onKeyDown={(e) => { if (e.key === 'Enter') enviarMensagem(); }}
                />
                <button onClick={enviarMensagem} className="modal-chat-send-btn" title="Enviar">
                    <span style={{ marginLeft: '2px', marginTop: '2px' }}>➤</span>
                </button>
            </div>
        </div>
    );
}

export default ChatWindow;